import { useTheme } from 'styled-components'

import { CountryFlag, Text } from '@reveni-io/reveni-ui'

import SizingIssuesReasonTag from '@/metrics/components/SizingIssuesReasonTag/SizingIssuesReasonTag'
import { getReasonProgressColor, getReasonTextColor, toPercent } from '@/metrics/helpers/helpers'

import * as Styles from './styles'

const CountryStatItem = ({ countryCode, countryName, data }) => {
  const theme = useTheme()
  const percentage = toPercent(data.local_percentage)
  const percentageColor = getReasonTextColor(data.reason, theme)
  const fillColor = getReasonProgressColor(data.reason, theme)

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.CountryInfo>
          <CountryFlag code={countryCode} />
          <Text type="bodyMMedium" color={theme.colors.accent.on}>
            {countryName}:
          </Text>
        </Styles.CountryInfo>

        <Styles.PercentageAndTag>
          <Text type="bodyMBold" color={percentageColor}>
            {percentage}%
          </Text>

          <SizingIssuesReasonTag reason={data.reason} />
        </Styles.PercentageAndTag>
      </Styles.Header>

      <Styles.ProgressTrack>
        <Styles.ProgressFiller
          data-testid="country-progress-filler"
          fillColor={fillColor}
          widthPercentage={percentage}
        />
      </Styles.ProgressTrack>
    </Styles.Container>
  )
}

export default CountryStatItem
